module.exports = __webpack_public_path__ + "static/media/モデル特性.5ea0f28c.pdf";